import { createContext } from 'react'

const SupplierInviteContext = createContext()

export default SupplierInviteContext
